export default __webpack_public_path__ + "static/25-6593e309377c1bc43586e947bd5c01c4.png";